import { useAuthStore } from '@/stores/auth'

const downloadFile = (blob, fileName) => {
  const urlBlob = window.URL.createObjectURL(blob)
  var a = document.createElement('a')
  a.href = urlBlob
  a.download = fileName
  a.style.display = 'none'
  a.setAttribute('download', fileName)
  a.click()
  window.URL.revokeObjectURL(urlBlob)
}

const getAttachment = async (id, token, fileName) => {
  const authStore = useAuthStore()
  if ((!id || !token) && authStore.user) return
  const {
    user: { userToken, refreshToken }
  } = authStore

  const url = `/api/attachment/${id}/${token}/view`

  const xhr = new XMLHttpRequest()
  xhr.withCredentials = true

  xhr.addEventListener('readystatechange', function () {
    if (this.readyState === 4) {
      downloadFile(this.response, fileName)
    }
  })

  xhr.open('GET', url, true)
  xhr.responseType = 'blob'
  xhr.setRequestHeader('languageId', '2')
  xhr.setRequestHeader('userToken', userToken)
  xhr.setRequestHeader('refreshToken', refreshToken)
  xhr.send()
}

export default function () {
  return {
    getAttachment,
    downloadFile
  }
}
